import {Component, Input, OnInit} from '@angular/core';
import {AdminTemplateComponent} from "../admin-template/admin-template.component";
import {MenuItem, TreeNode} from "primeng/api";
import {NgForOf, NgIf} from "@angular/common";
import {ChipsModule} from "primeng/chips";
import {FormsModule} from "@angular/forms";
import {CheckboxModule} from "primeng/checkbox";
import {DropdownFilterEvent, DropdownModule} from "primeng/dropdown";
import {Menu} from "primeng/menu";
import {TreeTable, TreeTableModule} from "primeng/treetable";
import {Setting} from "../../dto/Setting";
import _default from "chart.js/dist/plugins/plugin.tooltip";
import numbers = _default.defaults.animations.numbers;

@Component({
    selector: 'app-admin-menu-page',
    standalone: true,
    imports: [
        NgForOf,
        ChipsModule,
        FormsModule,
        CheckboxModule,
        DropdownModule,
        TreeTableModule,
        NgIf
    ],
    templateUrl: './admin-menu-page.component.html',
    styleUrl: './admin-menu-page.component.css'
})
export class AdminMenuPageComponent extends AdminTemplateComponent implements OnInit {
    @Input() settingType = "MENU";
    selectedSetting:Setting=new Setting();
    mainMenu: MenuItem[] = []
    listMenu: MenuItem[] = []
    selectedMenuItem: MenuItem ={};
    treeTbl: TreeNode[];
    selectedParent: MenuItem ;
    allNodeMap: Map<string, any> = new Map<string, any>();

    ngOnInit() {
        this.checkLogin();
        this.loadMenuSetting();
    }
     temp :Array<TreeNode> = new Array<TreeNode>();
    addNewMenuRow(tt: TreeTable) {
        // this.selectedMenuItem.target='_self';
        this.listMenu.push(this.selectedMenuItem);
        let node:TreeNode = {
            key:'0',
            label: this.selectedMenuItem['label'],
            data: this.selectedMenuItem,
            parent: null,
            children: null
        }


        if (this.selectedParent != null && this.selectedParent['id'] != null && this.selectedParent['id'].length > 0) {
            if (node.parent == null) {
                node.parent={};
            }
            node['parent'] = (this.allNodeMap.get(this.selectedParent['id']));
            let parent = this.allNodeMap.get(this.selectedParent['id']);
            if (parent.children || parent.children == null) {
                parent.children=[];
            }

            parent.children.push(node);
            let i=0;
            for (let ch of parent.children) {
                ch['key']=parent.key+(i++);
                ch['data']['id']=ch['key'];
            }

            if ((parent['data'] as MenuItem)['items']==null )
                (parent['data'] as MenuItem)['items'] = [];
            (parent['data'] as MenuItem)['items'].push(node['data']);
        } else {
            this.temp.push(node)
            if (this.treeTbl == null) {
                this.treeTbl=[];
            }
            for (let tttemp of this.treeTbl) {
                if (node.key < tttemp.key) {
                    node.key=tttemp.key;
                }
                node.key=(Number.parseInt(node.key)+1)+'';
                node.data['id']=node.key;
            }
            this.treeTbl= [...this.treeTbl, node];
        }
        this.allNodeMap.set(this.selectedMenuItem['id'], node);
        this.selectedMenuItem = {};
        this.selectedParent = null;
        this.treeToMenuItem();
        // this.menuToTree();
        this.saveMenu(null);


    }
    editMenu(){
        this.saveMenu(null);
        this.selectedMenuItem = {};
        this.selectedParent = null;
    }
    cancelEditMenu(){
        this.selectedMenuItem = {};
        this.selectedParent = null;
    }

    fillListItems(event: DropdownFilterEvent) {


    }
    loadMenuSetting(){
        this.global.progressBar = true;
        var observable = this.restBack.doGet("lnd/setting/get_setting?" +
            "&type="+this.settingType );
        observable.subscribe({
            next: (res: string) => {
                if (res["status"] == 200) {
                    this.selectedSetting = res["entity"];
                    this.mainMenu= JSON.parse(this.selectedSetting.data);
                    this.treeTbl=[];
                    this.menuToTree();


                }
                if (res["status"] == 401) {
                    this.gotoLogin();
                }
                return res;
            },
            error: (e) => {
                this.messageService.clear();
                this.messageService.add({
                        severity: 'error',
                        summary: $localize`:@@Error:Error`,
                        detail: $localize`:@@Server Timout Det:Server Timout Det`
                    }
                );
            },
            complete:()=>{
                this.global.progressBar = false;
            }
        });
    }
    saveMenu(msg){
        let params = {};
        this.selectedSetting.data=JSON.stringify(this.mainMenu);
        this.selectedSetting.type=this.settingType;
        let body = this.selectedSetting;
        this.global.progressBar = true;
        var observable = this.restBack.doPost("lnd/setting/save_setting", body, params);
        observable.then((res: string) => {
                if (res["status"] == 200) {
                    let o = res["entity"];
                    // this.loadIndexData(null);
                    if(msg==null || msg != "delete") {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: 'info',
                            summary: $localize`:@@Save_Success:Save Success`,
                            detail: $localize`:@@Save_Success_Det:Save_Success_Det`
                        });
                    }else {
                        this.messageService.clear();
                        this.messageService.add({
                                severity: 'info',
                                summary: $localize`:@@Delete:Delete`,
                                detail: $localize`:@@Delete Success:Delete Success`
                            }
                        );
                    }

                } else if (res["status"] == 400) {

                } else if (res["status"] == 401) {

                }
                return res;
            },
            error => {
                this.messageService.clear();
                this.messageService.add({
                        severity: 'error',
                        summary: $localize`:@@Error:Error`,
                        detail: $localize`:@@Server Timout Det:Server Timout Det`
                    }
                );
            }).finally(() => {
            this.global.progressBar = false;
            this.loadMenuSetting();


        });
    }

    removeMenuFromList(rowNode: any) {
        this.confirmationService.confirm({
            message: $localize`:@@Are you sure to delete?:Are you sure to delete?`,
            header: $localize`:@@Delete:Delete`,
            acceptLabel: $localize`:@@Yes:Yes`,
            rejectLabel: $localize`:@@No:No`,
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.mainMenu = this.removeFromMenuItem(this.mainMenu, rowNode['node']['data']);
                this.treeTbl = [];
                this.menuToTree();
                this.saveMenu("delete");
            }
        });

    }

    removeFromMenuItem(items:MenuItem[] , item:MenuItem){
        for (let item1 of items) {
            if (item1 == item) {
                var indx = items.indexOf(item,0);
                items.splice(indx,1);
            }else if(item1.items != null) {
                item1.items = this.removeFromMenuItem(item1.items,item);
            }
        }
        return items;
    }

    editMenuFromList(rowNode: any) {
        this.selectedMenuItem = rowNode['node']['data'];
        if ( rowNode['node']['parent'] != null) {
            this.selectedParent=rowNode['node']['parent']['data']
        }else {
            this.selectedParent=null;
        }

    }


    treeToMenuItem() {
        this.mainMenu=[];
        for (let treeTblElement of this.treeTbl) {
            if (treeTblElement.parent == null) {
                this.mainMenu.push(treeTblElement.data);
            }
        }
    }
    menuToTree(){
        this.listMenu=[];
        if (this.treeTbl == null) {
            this.treeTbl=[];
        }
        this.mainMenuToTreeNode(this.treeTbl,null,this.mainMenu,0);
    }
    mainMenuToTreeNode(treeNode:TreeNode[],parent:TreeNode,menu:MenuItem[],id:number) {

        for (let mm of menu) {
            mm.command = (e)=>{
                location.reload();
            };
            id++;
            let node:TreeNode = {
                key:id+'',
                label: mm['label'],
                data:mm,
                parent: parent,
                children: null
            }
            mm.id=id+"";
            this.listMenu.push(mm);
            this.allNodeMap.set(mm.id, node);
            if(mm.items!=null && mm.items.length>0){
                if(node.children==null )
                    node.children=[];
                this.mainMenuToTreeNode(node.children,node,mm.items,id*10);
            }
            treeNode.push(node);
        }
    }


}
